import { CustodianTypes } from 'services/requests';

export const mapCustodianTypeValueToKey = (type?: string) =>
  Object.entries(CustodianTypes).find((item) => item[1] === type)?.[0] ?? '';

export const mapCustodianTypeKeyToValue = (type?: string) =>
  Object.entries(CustodianTypes).find((item) => item[0] === type)?.[1] ?? '';
